import type { PruningInfo } from '../../types/careExpanded';

interface PruningSectionProps {
  pruning: PruningInfo;
}

export function PruningSection({ pruning }: PruningSectionProps) {
  return (
    <div className="space-y-4">
      {/* Timing and technique */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Best Time
          </dt>
          <dd className="mt-1 text-sm text-editorial-black font-medium">{pruning.timing}</dd>
        </div>
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500">
            Technique
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{pruning.technique}</dd>
        </div>
      </div>

      {/* Tips list */}
      {pruning.tips && pruning.tips.length > 0 && (
        <div>
          <dt className="text-xs font-medium uppercase tracking-wide text-gray-500 mb-2">
            Tips
          </dt>
          <ul className="space-y-1.5">
            {pruning.tips.map((tip, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-editorial-black">
                <span className="text-primary mt-0.5" aria-hidden="true">•</span>
                <span>{tip}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Additional notes */}
      {pruning.notes && (
        <div className="p-3 rounded-lg bg-primary/5 border border-primary/10">
          <dt className="text-xs font-medium uppercase tracking-wide text-primary">
            Note
          </dt>
          <dd className="mt-1 text-sm text-editorial-black">{pruning.notes}</dd>
        </div>
      )}
    </div>
  );
}
